import styled, {
  SystemProps,
  breakpoints,
  css,
  system,
  th,
} from 'quickstart/styled-components/system'

export const SIDENAV_COLUMN_GAP = '30px'

export const SideNav = styled.div<SystemProps>`
  ${breakpoints({
    lg: css`
      display: grid;
      grid-template-columns: 1fr 2fr;
      align-items: start;
      column-gap: ${SIDENAV_COLUMN_GAP};
    `,
  })};
  ${system};
`

export const SideNavItem = styled.div<{first?: boolean} & SystemProps>(
  ({first}) => css`
    padding: ${th('space.xl')} ${th('space.lg')};
    ${first &&
    css`
      border-top: ${th('borders.fine')};
    `};
    border-bottom: ${th('borders.fine')};
    ${system};
  `,
)

export const SideNavContent = styled.div<SystemProps>`
  ${system};
`
